import {Injectable} from "@angular/core";
import {Http, RequestOptions, Response, URLSearchParams} from "@angular/http";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';

@Injectable()
export class SearchApiObservableService {

    private options: RequestOptions;

    constructor(private _http: Http) {
        this.options = new RequestOptions();
    }

    searchRequestForUrl(url: string, param: FilterModel): Observable<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in param) {
            if (param.hasOwnProperty(key)) {
                let val = param[key];
                params.set(key, val);
            }
        }

        this.options = new RequestOptions({search: params});

        return this._http.get(url, this.options).map(SearchApiObservableService.extractData).catch(SearchApiObservableService.handleError);
    }

    private static extractData(res: Response) {
        let body = res.json();
        return body || {};
    }

    private static handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return Observable.throw(errMsg);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/search-api-observable.service.ts